import { defineComponent } from 'vue';
import ActNavigationCode from '@/presentation/components/act-access-modal/act-navigation/act-navigation.code';

export default defineComponent({
	setup: () => {
		const code = new ActNavigationCode();

		return {
			confirmButton: code.confirmButton,
			isPreviousStepPossible: code.isPreviousStepPossible,
			isNextStepPossible: code.isNextStepPossible,
			isLastStepReached: code.isLastStepReached,
			handleBackClick: code.handleBackClick.bind(code),
			handleNextClick: code.handleNextClick.bind(code)
		};
	}
});
